export const environment = {
  production: true,
  version: 'dd990bd64f',
  site_version: 'SITE_VERSION'
};
